import { useIntl } from "react-intl";

import { classNames } from "helpers/commonHelpers";

import "./PackingListRequiredHint.scss";

type PackingListRequiredHintProps = {
  className?: string;
};

export default function PackingListRequiredHint({ className }: Readonly<PackingListRequiredHintProps>) {
  const intl = useIntl();

  return (
    <span className={classNames("rfv2-packing-list-required-hint", className)}>
      {intl.formatMessage({
        id: "request-form.packing-list.requiredHint",
        defaultMessage: "*Required",
      })}
    </span>
  );
}
